// export const BASE_API_URL = "http://localhost:5000/v1/api"; // Dev
// export const BASE_API_URL = "http://localhost:8100"; // Dev Microservice
// export const BASE_API_URL = "http://10.124.134.11:30342"; // UIH Sit Microservice
// export const BASE_API_URL = "https://kongapi.nanotech-endp2.com"; // Staging
// export const BASE_API_URL = "https://kongapi.aotga.com"; // Production

// export const ENV_CHECK = "DEV";
// export const CUSTOMS_ENV = "DEV"
// export const CUSTOMS_ENV = "PROD"
export const ENV_CHECK = "PROD"

// export const PROX_URL = "https://proxy.nanotech-endp2.com/"
// export const NETBAY_URL = "https://uataotdc.netbay.co.th/"
// export const NETBAY_URL = "https://ezcargo.airportthai.co.th/"
// export const NETBAY_User = "interfacemtms";
// export const NETBAY_Password = "P@ssw0rd";
// export const NETBAY_Companycode = "AOTGA";

// Dev
// for call FAKE Customs API Then CUSTOMS_ENV = "DEV"
// export const CUSTOMS_ENV = "DEV"

// export const CUSTOMS_ENV = "PROD"
// export const BASE_API_URL = "http://localhost:8100"; 
// export const PROX_URL = "https://proxy.nanotech-endp2.com/"
// export const NETBAY_URL = "https://uataotdc.netbay.co.th/"
// export const NETBAY_User = "interfacemtms";
// export const NETBAY_Password = "P@ssw0rd";
// export const NETBAY_Companycode = "AOTGA";

// export const CUSTOMS_AUTH = "https://webservice-api.customs.go.th:9445/test-org/api-test/oauth-test-provider/"
// export const CUSTOMS_URL = "https://webservice-api.customs.go.th:9445/test-org/api-test/webserviceapi/WebServiceAPI_TEST/v1/ImportClearanceWS/"
// export const CUSTOMS_User = "WST01055611761360";
// export const CUSTOMS_Password = "KbjfSht6CnD9Fx7J";
// export const CUSTOMS_GRANT_TYPE = "client_credentials";
// export const CUSTOMS_CLIENT_ID = "6d8e0142179468100c0f85593decd681";
// export const CUSTOMS_CLIENT_SECRET = "58dcedbe1a57c637d8dc1a78476823eb";
// export const CUSTOMS_CLIENT_SCOPE = "webservice_scope";


// Staging
// for call FAKE Customs API Then CUSTOMS_ENV = "DEV"
// export const CUSTOMS_ENV = "DEV"

// export const CUSTOMS_ENV = "PROD"
// export const BASE_API_URL = "https://kongapi.nanotech-endp2.com";
// export const PROX_URL = "https://proxy.nanotech-endp2.com/"
// export const NETBAY_URL = "https://uataotdc.netbay.co.th/"
// export const NETBAY_User = "interfacemtms";
// export const NETBAY_Password = "P@ssw0rd";
// export const NETBAY_Companycode = "AOTGA";

// export const CUSTOMS_AUTH = "https://webservice-api.customs.go.th:9445/test-org/api-test/oauth-test-provider/"
// export const CUSTOMS_URL = "https://webservice-api.customs.go.th:9445/test-org/api-test/webserviceapi/WebServiceAPI_TEST/v1/ImportClearanceWS/"
// export const CUSTOMS_User = "WST01055611761360";
// export const CUSTOMS_Password = "KbjfSht6CnD9Fx7J";
// export const CUSTOMS_GRANT_TYPE = "client_credentials";
// export const CUSTOMS_CLIENT_ID = "6d8e0142179468100c0f85593decd681";
// export const CUSTOMS_CLIENT_SECRET = "58dcedbe1a57c637d8dc1a78476823eb";
// export const CUSTOMS_CLIENT_SCOPE = "webservice_scope";


// Production
export const CUSTOMS_ENV = "PROD"
export const BASE_API_URL = "https://kongapi.aotga.com";
export const PROX_URL = "https://proxy.nanotech-endp2.com/"
export const NETBAY_URL = "https://ezcargo.airportthai.co.th/"
export const NETBAY_User = "interfacemtms";
export const NETBAY_Password = "P@ssw0rd";
export const NETBAY_Companycode = "AOTGA";

export const CUSTOMS_AUTH = "https://webservice-api.customs.go.th/customs-org/api/oauth-provider/"
export const CUSTOMS_URL = "https://webservice-api.customs.go.th/customs-org/api/webserviceapi/WebServiceAPI/v1/ImportClearanceWS/"
export const CUSTOMS_User = "WSP01055611761360";
export const CUSTOMS_Password = "yWw837ftKVcNpjYL";
export const CUSTOMS_GRANT_TYPE = "client_credentials";
export const CUSTOMS_CLIENT_ID = "28dc48107e68a1fd2c66bdfe042402bb";
export const CUSTOMS_CLIENT_SECRET = "286adfb2ec9abdcac6401eb25c7be7fb";
export const CUSTOMS_CLIENT_SCOPE = "ImpClrScp01";